'use client';

import VisitorCounter from './VisitorCounter';

export default function VisitorBadge({ className }: { className?: string }) {
  return <VisitorCounter className={className} />;
}
